export const VAT_RATE = 0.25

export const CURRENCY_CODE = 'DKK'
